'use client';

import { useFooterScrollShadow } from '../../hooks/useFooterScrollShadow';
import { Box, token, VStack } from '@terra/ui-styled-system';
import { useLayoutEffect, type ReactNode } from 'react';

const SCROLL_BOTTOM_BOX_SHADOW = `inset 0 -8px 8px -8px ${token('colors.neutral.a3')}`;

type FilterBarListScrollLayoutProps = {
  filterBar: ReactNode;
  children: ReactNode;
  header?: ReactNode;
};

export const FilterBarListScrollLayout = ({
  filterBar,
  children,
  header,
}: FilterBarListScrollLayoutProps) => {
  const { scrollableRef, scrollContentRef, boxShadow, updateScrollState } =
    useFooterScrollShadow({
      boxShadow: SCROLL_BOTTOM_BOX_SHADOW,
    });

  useLayoutEffect(() => {
    updateScrollState();
  }, [updateScrollState, children]);

  return (
    <VStack alignItems="stretch" gap={0} w="full" h="full" minH={0} flex={1}>
      {header ? <Box flexShrink={0}>{header}</Box> : null}
      <Box flexShrink={0}>{filterBar}</Box>
      <Box
        ref={scrollableRef}
        onScroll={updateScrollState}
        flex={1}
        minH={0}
        overflowY="auto"
        pb={4}
        pr={3}
        style={{ boxShadow }}
      >
        <Box ref={scrollContentRef}>
          <VStack alignItems="stretch" gap={4} w="full">
            {children}
          </VStack>
        </Box>
      </Box>
    </VStack>
  );
};
